import script from "./BadgeComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BadgeComponent.vue?vue&type=script&setup=true&lang=ts"

import "./BadgeComponent.vue?vue&type=style&index=0&id=034fee6f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-034fee6f"]])

export default __exports__